module.exports = __webpack_public_path__ + "media/img/illustrations/icons/esr-chevron-5fd8b30c81e58ea5e9a30ab8518a095a.svg";